import { useContext } from 'react';
import { MissingSelectionValuesContext } from '../contexts/MissingSelectionValuesContext';

const useMissingSelectionValuesContext = () => {
  const context = useContext(MissingSelectionValuesContext);

  if (!context) {
    throw new Error('useMissingSelectionValuesContext must be used within a MissingSelectionValuesContextProvider');
  }

  return context;
};

export default useMissingSelectionValuesContext;
